import { Chip, Grid } from "@mui/material";
import { useAppSelector } from "../../../../app/hooks";
import { selectActivePlan } from "../nutrition-plan.slice";
import Meals from "./meals";
import { getTotalDayNutrition } from "../../../../shared/utils";

interface NutritionPlanDayProps {
    dayIndex: number;
}

const NutritionPlanDay = ({ dayIndex }: NutritionPlanDayProps) => {
    
    const activePlan = useAppSelector(selectActivePlan);
    const dayMeals = activePlan?.planSnapshot?.days?.[dayIndex]?.meals || [];
    const totalDayNutrition = getTotalDayNutrition(dayMeals);

    return ( 
        <>
            <Grid container justifyContent="center" spacing={1} sx={{ mb: 2 }}>
                <Chip label={`Calories: ${totalDayNutrition.calories}`} variant="filled" color="info" />
                <Chip label={`Protein: ${totalDayNutrition.protein}`} variant="filled" color="info" />
                <Chip label={`Carbs: ${totalDayNutrition.carbohydrates}`} variant="filled" color="info" />
                <Chip label={`Fat: ${totalDayNutrition.fat}`} variant="filled" color="info" />
                <Chip label={`Fiber: ${totalDayNutrition.fiber}`} variant="filled" color="info" />
                <Chip label={`Sugar: ${totalDayNutrition.sugar}`} variant="filled" color="info" />
            </Grid>
            <Meals dayIndex={dayIndex} />
        </>
     );
}

export default NutritionPlanDay;